/** Tipos de servicio visibles en intranet Servifin: solo Factoring y Crédito. */

const EXCLUDED_CODIGOS = ['CONF', 'DESC', 'PROP'];

function normalizeText(value: any): string {
  return String(value || '')
    .toUpperCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();
}

function isCredito(item: any): boolean {
  const codigo = normalizeText(item.Codigo);
  const desc = normalizeText(item.Descripcion);
  return codigo === 'CRED'
    || codigo === 'CRE'
    || codigo.startsWith('CRED')
    || desc.includes('CREDITO');
}

function isFactoring(item: any): boolean {
  const codigo = normalizeText(item.Codigo);
  const desc = normalizeText(item.Descripcion);
  if (codigo === 'FACT' || codigo === 'FACTORING') {
    return true;
  }
  return (desc.includes('FACTORING') || desc.includes('FACTOR')) && !desc.includes('CONFIRM');
}

function isExcluded(item: any): boolean {
  const codigo = normalizeText(item.Codigo);
  const desc = normalizeText(item.Descripcion);
  if (EXCLUDED_CODIGOS.indexOf(codigo) >= 0) {
    return true;
  }
  if (codigo.startsWith('CONF') || desc.includes('CONFIRMING')) {
    return true;
  }
  if (codigo.startsWith('DESC') || desc.includes('DESCUENTO')) {
    return true;
  }
  if (codigo === 'PROP' || desc.includes('PRONTO PAGO')) {
    return true;
  }
  return false;
}

export function filterServifinTiposServicio(tipos: any[]): any[] {
  if (!Array.isArray(tipos)) {
    return [];
  }
  return tipos.filter(item => !isExcluded(item) && (isFactoring(item) || isCredito(item)));
}

export function resolveCreditoTipoServicioId(tipos: any[]): number | null {
  const item = filterServifinTiposServicio(tipos).find(isCredito);
  return item ? Number(item.idGuia) : null;
}
